// const react_env = process.env.REACT_APP_NODE_ENV;

// let ORIGIN = "localhost:5009/graphql";
let ORIGIN = process.env.REACT_APP_GRAPHQL_ORIGIN;

let GRAPHQL_URL_CONSTANT = `http://${ORIGIN}`;

if (process.env.REACT_APP_NODE_ENV === "production") {
  GRAPHQL_URL_CONSTANT = `https://${ORIGIN}`;
}

export const GRAPHQL_URL = GRAPHQL_URL_CONSTANT;
export const GRAPHQL_URL_WS = `ws://${ORIGIN}`;

export const UserRole = {
  SuperAdmin: "SuperAdmin",
  SiteAdmin: "SiteAdmin",
  MTGroup: "MTGroup", // <-- All Micron Members should be in this role? No.
  ContractorPM: "ContractorPM",
  ContractorRequestor: "ContractorRequestor",
  MicronSupervisor: "MicronSupervisor", // remove?
  MicronManager: "MicronManager", // remove?
  User: "User", // <-- Will be the default role when they signed in using SSO
};

export const UserStatus = { Pending: "Pending", Approved: "Approved", Rejected: "Rejected" };
export const PermitStatus = {
  Pending: "Pending",
  Approved: "Approved",
  Rejected: "Rejected",
  PendingApproval: "PendingApproval",
  Completed: "Completed",
  Cancelled: "Cancelled",
  PendingClosure: "PendingClosure",
  PendingCancel: "PendingCancel",
  DraftPermit: "DraftPermit",
  Executed: "Executed",
  MergedIntoParent: "MergedIntoParent",
};

export const StatusColor = {
  Pending: "orange",
  Approved: "green",
  Rejected: "red",
  PendingApproval: "orange",
  Completed: "#108ee9",
  Cancelled: "#de0202",
  PendingClosure: "#FFA500",
  PendingCancel: "#FFD000",
  Executed: "#5499C7",
  MergedIntoParent: "#5499C7",
};

export const PermitType = {
  G: "General",
  S: "SIPP",
  H: "Hotwork",
  W: "Work At height",
  C: "Confined Space",
  L: "Lifting",
  LSS: "Life Support System",
  LE: "Live Electrical",
  // A: "" // <-- For A Permits? Or Default Permit Type?
};

export const __data = [
  { fileName: "01-Risk Assessment_v2.pdf", lastUpdated: "26 July 2021" },
  { fileName: "02-Ladder Inspection Checklist.pdf", lastUpdated: "29 March 2021" },
  { fileName: "03-AirReceiver Compressor Generator Checklist.pdf", lastUpdated: "29 March 2021" },
  { fileName: "04-Excavation Checklist.pdf", lastUpdated: "29 March 2021" },
  { fileName: "05-Scaffold Checklist.pdf", lastUpdated: "07 Oct 2021" },
  { fileName: "06-Raised Metal Flooring Checklist_v2.pdf", lastUpdated: "26 July 2021" },
  { fileName: "07-SRDSLD Checklist.pdf", lastUpdated: "29 March 2021" },
  { fileName: "08-Hot_Work_Signage.pdf", lastUpdated: "26 September 2025" },
  { fileName: "09-Confined_Space_Signage.pdf", lastUpdated: "26 September 2025" },
];

export const S3_BASE_URL = "https://f10eptw-prod.s3.ap-southeast-1.amazonaws.com";

export const userGuides = [
  {
    fileName: "User Guide v3.0.pdf",
    lastUpdated: "10 April 2026",
    s3Url: "User Guide v3.0.pdf",
  },
];

export const youtubeLinks = [
  {
    fileName: "01 Introduction ePTW",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/REy0jJznQwY",
  },
  {
    fileName: "02 ePTW System login",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/A96J5HDQXZ4",
  },
  {
    fileName: "03 User Guide",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/1hcOx17s_fY",
  },
  {
    fileName: "04 Parent & Child Permit",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/ZuWZ5teKZv4",
  },
  {
    fileName: "05 B1 Hotwork permit",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/lHot0EywbkU",
  },
  {
    fileName: "06 B2 ConfinedSpace",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/wT2KkHXdW5E",
  },
  {
    fileName: "07 B3 Lifting",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/kvxmCZ63XOc",
  },
  {
    fileName: "08 B4 Work at Height",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/IbiJaiYvzCM",
  },
  {
    fileName: "09 B5 LSS",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/mz0l4VI45rA ",
  },
  {
    fileName: "10 B6 Live Electrical",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/mJB8QBY8QLg",
  },
  {
    fileName: "11 B7 SIPP",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/1xqUltWOQlU",
  },
  {
    fileName: "12 B8 Dirty Permit",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/QoXIRWorWkA",
  },
  {
    fileName: "13 Approval and Rejection flow",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/v1pzKhKO4Zc",
  },
  {
    fileName: "14 Requester Initiate Pending Closure",
    lastUpdated: "10 April 2026",
    url: "https://youtu.be/xqZTRPpZ__o",
  },
];

export const PermitStatusArray = [
  { text: "Pending Approval by PM", value: "Pending" },
  { text: "PendingApproval by Reviewers", value: "PendingApproval" },
  { text: "Approved", value: "Approved" },
  { text: "PendingClosure", value: "PendingClosure" },
  { text: "PendingCancel", value: "PendingCancel" },
  { text: "Completed", value: "Completed" },
  { text: "Cancelled", value: "Cancelled" },
  { text: "Rejected", value: "Rejected" },
];

export const InterlockDisclaimer = (
  <p>
    Dear Requester, as you have 3 or more Pending Closure permits, you are not allowed to create new permits. Please
    ensure your permits are all closed in order to create new permits.
  </p>
);

export const UnclosedPermitDisclaimer = (
  <p>
    Dear Requester, as you have 2 or more unclosed permits, you are not allowed to create new permits. Please ensure
    your permits are all closed in order to create new permits.
  </p>
);

export const UnfilledRequiredFieldsToolTip = (
  <p>Some required fields are empty. Please fill out the fields before you continue.</p>
);

export const deleteButtonToolTip = <span>Interlock Update: Deleting Required Uploaded File is not allowed...</span>;
